import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSheet,{staticClass:"mb-6 pa-2 py-md-6 px-md-8",attrs:{"elevation":"1"}},[_vm._t("header",[_c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"page-title"},[_c('h3',{staticClass:"page-header-title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"page-buttons"},[_vm._t("buttons")],2)])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }